class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, options = {}) {
      const silent = options.silent === true;
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        const sectionId = section.section || section.id;
        const html = parsedState.sections[sectionId];
        if (!html) return;
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(html, section.selector);
      }));

      // Quick-add (plus button on product cards) updates the cart icon only,
      // without opening the slide-in notification popup — keeps browsing uninterrupted.
      if (silent) return;

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
    if (document.getElementById('cart-notification-free-shipping-bar')) {
      sections.push({
        id: 'cart-notification-free-shipping-bar',
        section: 'cart-notification',
        selector: '#cart-notification-free-shipping-bar'
      });
    }
    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('#cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
